export default __webpack_public_path__ + "static/media/qbittorrent.c7b87ebb.png";